// extracted by mini-css-extract-plugin
export default {"logo":"LorginForm_logo__chD8W","input":"LorginForm_input__Otece"};